/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Order_Settlement_Amount_DueInputs */

const vi_order_settlement_amount_due = /** @type {(inputs: Order_Settlement_Amount_DueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Còn phải thu: ${i?.amount}`)
};

/**

* @param {Order_Settlement_Amount_DueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_amount_due = /** @type {((inputs: Order_Settlement_Amount_DueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Amount_DueInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_amount_due(inputs)
});